import { createCrudApi } from './crud';

export type ProjectStatus = 'planned' | 'active' | 'on_hold' | 'completed' | 'closed' | 'cancelled';

export interface Project {
  id: number;
  projectCode: string;
  projectName: string;
  clientId: number;
  startDate: string | null;
  endDate: string | null;
  regionId: number | null;
  stateId: number | null;
  status: ProjectStatus;
  createdAt: string;
}

export interface CreateProjectInput {
  projectName: string;
  clientId: number;
  startDate?: string;
  endDate?: string;
  regionId?: number | null;
  stateId?: number | null;
  status?: ProjectStatus;
}

// clientId is immutable; update payload omits it.
export type UpdateProjectInput = Omit<Partial<CreateProjectInput>, 'clientId'>;

export const projectsApi = createCrudApi<Project, CreateProjectInput, UpdateProjectInput>('projects');
